/*
Keys of Remainng

*/

import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { colorSchemes, generalTheme, themes } from './theme.const';


declare function success(m)
declare function alerts(m)
declare var $: any;

//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';



@Injectable({
  providedIn: 'root'
})
export class ThemeOptionsService {

  loginUrl = "http://localhost:8090/genius_gst";
  genmasterTokenUrl = `http://localhost:8090`;
  projectinfourl = `http://localhost:7777`;


  constructor(private http: HttpClient) { }

  breadCrumb = new EventEmitter();
  lang = new EventEmitter();
  dashFlag: Subject<boolean> = new Subject<boolean>();
  //  selectedColorScheme: Subject<any> = new Subject<any>();

  emitBreadCrumbValue(value) {
    this.breadCrumb.emit(value);
  }

  emitLanguage(value) {
    this.lang.emit(value);
  }

  sidebarSource = new BehaviorSubject(false); // false === left sidebar
  changeSidebar = this.sidebarSource.asObservable();

  themeName: string;
  isThemeChanged: Subject<string> = new Subject<string>();
  themeColor: Subject<string> = new Subject<string>();



  get getThemeName() {
    return this.isThemeChanged.asObservable();
  }

  setThemeColor(themeColor: string, themeName: string) {
    this.themeColor.next(themeColor);
    this.isThemeChanged.next(themeName);
  }


  setTheme(theme: string) {
    this.isThemeChanged.next(theme);
  }

  applyClass() {
    var body = $('body');
    body.tooltip({
      selector: '[data-toggle="tooltip"]'
    });
    body.popover({
      selector: '[data-toggle="popover"]'
    });


    $('.sidebar-toggle').on('click', function (e) {
      e.preventDefault();
      $('.sidebar').toggleClass('toggled');
      $('.bodyMain').toggleClass('toggled-sidebar');

    });

    $('.rightbar-toggle').on('click', function (e) {
      e.preventDefault();
      $('.rightbar').toggleClass('toggled');
      $('.bodyMain').toggleClass('toggled-rightbar');
    });
  }

  /* add Active Class in leftmenu --varun jain*/
  activeClassFunc() {
    var element = event.target as HTMLElement;
    if (element.tagName == "A") {
      if (element.hasAttribute("data-toggle")) {
        let list = element.nextElementSibling.children; //submenu

        if (!element.classList.contains("active")) {
          var childEle = (element.parentElement.tagName == "DIV") ? element.parentElement.parentElement.parentElement.children : element.parentElement.parentElement.children;
          remove(childEle);
          remove(list);
        }
        element.classList.toggle("active");
        remove(list)
      }
      else {
        var childEle = element.parentElement.parentElement.children;
        remove(childEle)
        element.classList.add("active");
      }
    }

    function remove(ele: HTMLCollection) {
      for (let _li of Array.from(ele)) {
        for (let _a of Array.from(_li.children)) {
          if (_a.tagName == "DIV" && _a.firstElementChild.tagName == "A")
            _a.firstElementChild.classList.remove("active");
          else
            _a.classList.remove("active");
        }
      }
    }
  }

  setDash(dashFlag) {
    this.dashFlag.next(dashFlag);
  }

  setSidebar(value: boolean) {
    this.sidebarSource.next(value);

    //added by Varun (on changing menu position)
    // if (value)
    // this.shareService.setData("menuPosition", "top")
    // else
    // this.shareService.setData("menuPosition", "left")
  }

  /* end add active class in side menu */

  /* apply custom setting in app, option-detail */
  id: string;
  name: string;
  dTemplate: string;
  jsonData: any;
  userId: string;
  sagClientId: string;

  themeObj = themes;
  selectedTheme_id: string = "1";
  // themeColorScheme : string = "1.1";
  themeColorScheme: string = "";
  rootVariables = "";
  generalTheme = generalTheme;
  allColorSchemes = colorSchemes;
  propertyVal = {};
  _dashFlag = '1';
  selectedTheme: string = 'default';
  selectedBackground: string = 'default';
  menuPosition: string = '1';
  selectedThemeIndex: number = 0;
  selectedColorScheme: any = [];
  initialize: any;
  rightside_variables: any = this.themeObj[this.selectedThemeIndex].theme_data;

  theme_css: string;


  getThemeOptionJSON() {
    if ((!sessionStorage.getItem("previousPathName") || sessionStorage.getItem("previousPathName") == null)) {
      let selectedId: any;
      this.getDataDirectBaseUrl('api/userDetails').subscribe(res => {
        if (res["data"]) {
          this.userId = selectedId = res["data"].clientInfo.usrId;
          this.sagClientId = res["data"].clientInfo.sagclientId;
          this.name = res["data"].clientInfo.usrName;
        }
        if (selectedId) {
          this.getDataDirectBaseUrl(`theme/getUserThemeJson/${selectedId}`).subscribe(res => {
            if (res) {
              if (res['status'] != 0) {
                this.id = res['result'].id;
                this.propertyVal = JSON.parse(res['result'].json);
                // start new work 
                let testJsonObj = JSON.parse(res['result'].json);
                this.themeColorScheme = testJsonObj.themeColorScheme;
                if (this.themeColorScheme) {
                  this.selectedTheme_id = testJsonObj.themeColorScheme.split('.')[0];
                  this.selectedThemeIndex = Math.abs(Number(this.selectedTheme_id) - 1);
                  this.selectedColorScheme = this.allColorSchemes.filter(e => e.theme_id == this.selectedTheme_id)[0].color_skins;

                  // set ccss according to theme
                  this.themeChange(this.selectedThemeIndex);

                  // end new work 

                  for (let i of this.rightside_variables) {
                    for (let a of i.section_fields) {
                      if (a.inputType == 'color') {
                        a['--value'] = this.propertyVal['themeColors']['--' + a.name];
                      }
                      if (a.inputType == 'selectOption') {
                        a['--value'] = this.propertyVal['themeIcons']['--' + a.name];
                      }
                    }
                  }
                  this.menuPosition = this.propertyVal['menuPosition'];
                  if (this.menuPosition != '1') {
                    this.setToggleSidebar(this.menuPosition)
                  };

                  this.selectedBackground = this.propertyVal['selectedBackground'];
                  if (this.selectedBackground != 'default') {
                    this.changeBackground(this.selectedBackground)
                  };

                  this._dashFlag = this.propertyVal['selectedDashboard'];
                  if (this._dashFlag != '1') {
                    // this.changeDashboard(this.dashFlag)
                  };

                  this.selectedTheme = this.propertyVal['selectedTheme'];
                  let themeIndex = this.generalTheme.findIndex(e => e.theme_name == this.propertyVal['selectedTheme'])
                  if ((this.selectedTheme).toLocaleLowerCase() != 'default' && themeIndex) {
                    this.themeChange(themeIndex)
                  };

                  this.getCurrentSCSSVariables(res);
                }
              }
            }
          })
        }
      })
    }
  }


  getCurrentSCSSVariables(res) {
    const self = this;
    const _url = document.querySelector("#current_css")['href'];
    $.ajax({
      url: _url,
      dataType: "text",
      success: function (cssText) {
        const rootVariables = cssText.split(":root")[1].split("}")[0];
        self.setVariableInHeaderHandler(res, rootVariables);
      }
    });
  }


  setVariableInHeaderHandler(resJson: any, rootVariables: any) {
    // console.log("Set SCSS in Header ++++++++++++++++++++++ ");
    // get and set variable from database.
    // debugger;
    let rJson_0 = {};
    Object.assign(rJson_0, JSON.parse(resJson.result.json));
    let all_var = { ...rJson_0['themeColors'], ...rJson_0['themeIcons'] };
    let rJson_1 = JSON.stringify(all_var) + '';
    // var rJson_2 = rJson_1.replaceAll("'",'"');
    var rJson_3 = rJson_1.replace(/\"/g, "");
    var res_json = ":root " + rJson_3.replace(/rgba\(/g, '').replace(/\)/g, '').replace(/\,--/g, ';--');
    var style = document.querySelector('#mySCSS');
    if (style === undefined || style === null) {
      style = document.createElement('style');
      style.setAttribute("type", "text/css");
      style.setAttribute("id", "mySCSS");
    };
    style.innerHTML = res_json;

    document.getElementsByTagName('head')[0].appendChild(style);
    this.setVariableInConstentHandler(rootVariables, rJson_3);
  }


  setVariableInConstentHandler(rootv: any, databaseVariable: any) {
    // console.log("Set CURRENT SCSS in service ++++++++++++++++++++++ ");
    // get and set current variable from current css file. like a7-default.css
    // than merge with current database :root varriable 
    // than set in theme-option variable for right side color and theme-options.
    // like sidebar, topbar, navigation, formdesign etc.
    // debugger;
    // console.log(rootv);
    // console.log(databaseVariable);

    const new_root = rootv.replace(/\s/g, '');
    const arr_0 = new_root.replace(/--|rgba\(|var\(|\)|\{/g, '');
    const arr_10 = arr_0.split(';');

    // remove wrong elements.
    const arr_101 = arr_10.filter((item) => {
      if (item.indexOf(':') != -1) {
        return item
      }
    })

    // set root array in real Array of Object of default Root Values..
    const root_arr01 = arr_101.map((item) => {
      if (item.includes(':')) {
        const _key = item.split(":")[0];
        const _v1 = item.split(":")[1];
        return item = { [_key]: _v1 }
      }
    })


    let root_arr = [];
    for (let i of root_arr01) {
      for (let j of this.selectedColorScheme) {
        if (Object.keys(i)[0] == Object.keys(j)[0]) {
          Object.assign(i, j);
        }
      }
      root_arr.push({ ...i });
    }

    let finalJson: any = [];

    // console.log(root_arr);
    // database string to conver Array of Object.
    // calling from firs load and databaseVariable == CSS Varible string. JSON Object.

    const arr_01 = databaseVariable.split('--');
    const arr_11 = arr_01.filter((item) => { if (item.indexOf(':') != -1) { return item } });
    let arr_111 = [];
    arr_11.forEach((item) => {
      const _k2 = item.replace(/rgba\(|\),/g, "").split(":")[0];
      let _v2 = '';
      if (_k2.includes('Icon') || _k2.includes('LblPos') || _k2.includes('Shape')) {
        _v2 = item.replace(/rgba\(|\),|\}|,/g, "").split(":")[1];
      } else {
        _v2 = item.replace(/rgba\(|\),|\}/g, "").split(":")[1];
      }
      const elem = { [_k2]: _v2 };
      arr_111.push(elem);
    });
    // console.log(root_arr);
    // console.log(arr_111);
    // merge both object 
    finalJson = root_arr.map((item) => {
      let _matched: any = [];
      if (arr_111.length > 0) {
        _matched = arr_111.filter((fitem) => {
          if (Object.keys(item)[0] == Object.keys(fitem)[0]) {
            return fitem
          }
        });
      }
      if (_matched.length > 0 && arr_111.length > 0) {
        item[Object.keys(item)[0]] = _matched[0][Object.keys(item)[0]];
      } else {
        if ((Object.keys(item)[0]).includes('Icon') ||
          (Object.keys(item)[0]).includes('LblPos') ||
          (Object.keys(item)[0]).includes('Shape')) {
          item[Object.keys(item)[0]] = Object.values(item)[0];
        } else {
          item[Object.keys(item)[0]] = "rgba(" + Object.values(item)[0] + ")";
        }
      }
      return item
    })

    // console.log(this.rightside_variables);
    // set all variables in my rightside component
    const _newwork = this.getGeneratedJson(this.rightside_variables, finalJson);

    Object.assign(this.rightside_variables, _newwork);
    // console.log(this.rightside_variables);

  }

  setToggleSidebar(ev: any): void {
    // debugger;
    const _targetValue: any = (ev == '1') ? false : true;
    this.menuPosition = ev;
    this.setSidebar(_targetValue);
    let classList = " ";
    if (_targetValue == true) {
      // this.document.body.classList.add('topMenu');
      // this.shareService.topmenu(_targetValue);
    } else {
      // this.document.body.classList.remove('topMenu');
      // this.shareService.topmenu(_targetValue);
    }
    $('.modal-full-screen').sagFullScreenModal({ "callFromDirective": false })
  }



  themeChange(indexValue: any) {
    if (indexValue >= 0) {
      // debugger;
      this.selectedThemeIndex = indexValue;
      this.rightside_variables = this.themeObj[0].theme_data;
      //this.selectedTheme = this.themeObj[0]["theme_class"];
      this.selectedTheme = this.generalTheme[this.selectedThemeIndex].theme_name;
      this.selectedTheme_id = this.generalTheme[this.selectedThemeIndex].theme_id;
      let _themeColorScheme = (this.themeColorScheme.split('.')[0] == this.selectedTheme_id) ?
        this.themeColorScheme : this.selectedTheme_id + '.1';
      // this.themeColorScheme = indexValue + '.' + 1;
      // this.themeColorScheme = (Number(indexValue)+1) + '.' + 1; 
      this.setTheme(this.selectedTheme);
      const _cssLink = this.generalTheme[this.selectedThemeIndex].css_path;
      const _themecss = document.querySelector("#current_css");
      _themecss.setAttribute('href', _cssLink);
      const resTheme = colorSchemes.filter(e => e.theme_id === this.selectedTheme_id);
      this.selectedColorScheme = (resTheme.length > 0) ? resTheme[0]['color_skins'] : [];
      // const default_color_scheme = (Number(indexValue++))+'.1';
      this.changeColorScheme(_themeColorScheme, true);
    }
  }

  removeInlineStyleHandler() {
    const el: HTMLElement = document.querySelector("app-root");
    el.removeAttribute('style');

  }

  changeBackground(value: any) {
    // if (this.document.getElementById("homeBodyBg"))
    //   this.document.getElementById("homeBodyBg").style.setProperty("background-image", "url('assets/images/backgrounds/" + value + ".jpg')");
    // this.selectedBackground = value;
  }




  /* end apply custom setting option-detail.component.ts */




  setVariableInHeaderHandlerOnClick(resJson: any) {
    // console.log("Set SCSS in Header ++++++++++++++++++++++ ");
    // get and set variable from database.
    // debugger;

    let newObj = '';
    resJson.forEach((el) => {
      let _el_f: string = Object.values(el) + "";
      let _el_s: string = _el_f.replace(/rgba\(|\)/g, '');
      newObj += '--' + Object.keys(el) + ': ' + _el_s + ';'
    })

    var res_json = ":root {" + newObj + "}";
    var style = document.querySelector('#mySCSS');
    if (style === undefined || style === null) {
      style = document.createElement('style');
      style.setAttribute("type", "text/css");
      style.setAttribute("id", "mySCSS");
    };
    style.innerHTML = res_json;

    document.getElementsByTagName('head')[0].appendChild(style);

    // this.setVariableInConstentHandler(rootVariables, rJson_3);
  }

  setVariableInConstentHandlerOnClick(rootv: any, databaseVariable: any) {
    // console.log("Set CURRENT SCSS in service on Color Scheme Change ++++++++++++++++++++++ ");
    // get and set current variable from current css file. like a7-default.css
    // than merge with current database :root varriable 
    // than set in theme-option variable for right side color and theme-options.
    // like sidebar, topbar, navigation, formdesign etc.
    // debugger;
    // console.log(rootv);
    // console.log(databaseVariable);

    this.setVariableInHeaderHandlerOnClick(databaseVariable);

    // const new_root = rootv.replaceAll(/(\r\n|\n|\r)/gm, "").replace(/\s/g,'');
    const new_root = rootv.replace(/\s/g, '');
    const arr_0 = new_root.replace(/--|rgba\(|var\(|\)|\{/g, '');
    const arr_10 = arr_0.split(';');

    // remove wrong elements.
    const arr_101 = arr_10.filter((item) => {
      if (item.indexOf(':') != -1) {
        return item
      }
    })

    // set root array in real Array of Object of default Root Values..
    const root_arr01 = arr_101.map((item) => {
      if (item.includes(':')) {
        const _key = item.split(":")[0];
        const _v1 = item.split(":")[1];
        return item = { [_key]: _v1 }
      }
    })

    let root_arr = [];
    for (let i of root_arr01) {
      for (let j of databaseVariable) {
        if (Object.keys(i)[0] == Object.keys(j)[0]) {
          Object.assign(i, j);
        }
      }
      root_arr.push({ ...i });
    }
    // merge both object 
    const finalJson = root_arr.map((item) => {
      // item[Object.keys(item)[0]] = "rgba("+Object.values(item)[0]+")";
      item[Object.keys(item)[0]] = Object.values(item)[0];
      return item
    })
    // console.log(this.rightside_variables);
    // set all variables in my rightside component
    const _newwork = this.getGeneratedJson(this.rightside_variables, finalJson);

    Object.assign(this.rightside_variables, _newwork);
    // console.log(this.rightside_variables);

  }

  getGeneratedJson(rightside_variables: any, finalJson: any) {

    const _newwork = rightside_variables.map((item: any) => {
      const updated_item = item.section_fields.map((sub_item: any) => {

        let finalV: any = "";
        if (sub_item.inputType == "color") {
          finalV = "rgba(999, 999, 999, 999)";   // set default value
        } else if (sub_item.inputType == "selectOption") {
          finalV = "inline-block";         // set default value
        }

        const _val = finalJson.filter((f_item) => {
          if (sub_item.name === Object.keys(f_item)[0]) {
            return f_item
          }
        })

        if (_val.length > 0) {
          let varkey: any = Object.keys(_val[0])[0];
          let varVal: any = Object.values(_val[0])[0];

          // check if varVal is a string like "purple"
          if (sub_item.inputType == "color") {
            if (varVal.indexOf(",") === -1) {
              // get value from 
              const used_arr: any = finalJson.filter((elem: any) => {
                if (Object.keys(elem)[0] === varkey) {
                  return elem
                }
              });

              if (used_arr.length > 0) {
                let fval_0: any = Object.values(used_arr[0])[0];
                let fval_1: any = fval_0.replace(/rgba\(|\)|\}/g, "");

                // finalV = "rgba("+fval+")";
                const _vla201 = finalJson.filter((e) => {
                  if (fval_1 === Object.keys(e)[0]) {
                    return e
                  }
                })[0];
                if (_vla201) {
                  finalV = Object.values(_vla201)[0];
                }
                // console.log(finalV);
              }
            } else {
              finalV = "rgba(" + varVal + ")";
            }
          } else if (sub_item.inputType == "selectOption") {
            if (varVal.indexOf(",") === -1) {
              // get value from 
              const used_arr: any = finalJson.filter((elem: any) => {
                if (Object.keys(elem)[0] === varkey) {
                  return elem
                }
              });

              if (used_arr.length > 0) {
                let fval_0: any = Object.values(used_arr[0])[0];
                let fval_1: any = fval_0.replace(/rgba\(|\)|\}/g, "");
                finalV = fval_1;

                // finalV = "rgba("+fval+")";
                const _vla201 = finalJson.filter((e) => {
                  if (fval_1 === Object.keys(e)[0]) {
                    return e
                  }
                })[0];
                if (_vla201) {
                  finalV = Object.values(_vla201)[0];
                }
                // console.log(finalV);
              }
            } else {
              finalV = varVal;
            }
          }


          // console.log(finalV);
        }

        sub_item['--value'] = finalV;

        return sub_item;
      })
      return item = { ...item, "section_fields": updated_item }
    })
    return _newwork;
  }

  changeColorScheme(theme_scheme_id: string, clackFalg: Boolean) {
    // if (confirm("Do you REALLY want change Theme?")){
    // theme_scheme_id = "1.1"
    // debugger;
    // this.allColorSchemes;
    if (clackFalg) {
      //if (this.document.getElementById("colorScheme")){
      // this.document.getElementById("homeBodyBg").style.setProperty("background-image", "url('assets/images/backgrounds/" + theme_scheme_id + ".jpg')");
      this.selectedTheme_id = theme_scheme_id.split('.')[0];
      this.themeColorScheme = theme_scheme_id;
      this.selectedThemeIndex = Number(this.selectedTheme_id) - 1;
    }
    this.updateClrSchemeInThemeConstentHandler(theme_scheme_id);
    // }

  }

  alterColorScheme(theme_scheme_id: string) {
    // theme_scheme_id = "1.1"
    // debugger;
    // console.log(theme_scheme_id);

  }

  updateClrSchemeInThemeConstentHandler(theme_scheme_id: any) {
    // theme_scheme_id = "1.1"
    // debugger;
    const self = this;
    const V1 = theme_scheme_id.split('.')[0];
    const scheme_group1 = this.allColorSchemes.filter(e => e.theme_id == V1);
    let crntSchem: any = [];
    if (scheme_group1.length > 0) {
      const scheme_group: any[] = scheme_group1[0].color_skins;
      crntSchem = scheme_group.filter(e => e.color_scheme == theme_scheme_id)[0].theme_data;
    }
    const _url = document.querySelector("#current_css")['href'];
    $.ajax({
      url: _url,
      dataType: "text",
      success: function (cssText) {
        const cssVariables = cssText.split(":root")[1].split("}")[0];
        self.setVariableInConstentHandlerOnClick(cssVariables, crntSchem);
      },
      complete: function () {
        self.removeInlineStyleHandler();
      }
    });

  }

  changeColor1(value: any, propName: string) {
    // debugger;
    const _url = document.querySelector("#mySCSS");
    let rootVar = _url.innerHTML.split(":root")[1].split("}")[0];
    rootVar = rootVar.replace(/\{|\}|--|rgba\(|var\(|\)|\{/g, '');
    rootVar = rootVar.replace(/\s/g, '');
    let rootArr = rootVar.split(';');
    let _rootArr = rootArr.filter(e => e.length > 0);
    const f_root = _rootArr.map(e => {
      let elem = e.split(':');
      return { [elem[0]]: elem[1] };
    })
  
    const nvalue = value.substring(4).substr(0, value.substring(4).length - 1);
    let styleStr = "";
    styleStr += ":root{";
    const finalRoot = f_root.forEach(elem => {
      if (Object.keys(elem)[0] == propName) {
        elem[propName] = nvalue;
      };
      let singleStr = "--" + Object.keys(elem)[0] + ":" + Object.values(elem)[0] + ";";
      styleStr += singleStr;
      return elem;
    });
    styleStr += "}";
    // console.log(finalRoot);
    // console.log(styleStr);

    _url.innerHTML = styleStr;
  }

  public postDataDirectBaseUrl(subURL, reqJson) {
    return this.http.post(`${'directBaseUrl'}/${subURL}`, reqJson);
  }
  public getDataDirectBaseUrl(subURL) {
    return this.http.get(`${'directBaseUrl'}/${subURL}`);
  }

}
